import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import {
  B2CSubscriptionState,
  B2CSubscriptionImportAction,
  B2CSubscriptionImportActionToString,
  B2CSubscriptionStateToString,
} from '../../invoice/model/const/enum-b2c';

export class ContactB2CSubscriptionInformation extends ModelBase {
  constructor(data?: any) {
    super();

    if (data) {
      this.issuerIdentity = data.issuerIdentity;
      this.recipientIdentity = data.recipientIdentity;
      this.currentState = data.currentState;
      this.stateChange = data.stateChange;
      this.stateChangedDate = data.stateChangedDate;
    }
  }

  issuerIdentity: string;
  recipientIdentity: string;
  currentState: B2CSubscriptionState;
  stateChange: B2CSubscriptionImportAction;
  stateChangedDate: Date;

  get currentStateCaption(): string {
    return B2CSubscriptionStateToString(this.currentState);
  }

  get stateChangeCaption(): string {
    return B2CSubscriptionImportActionToString(this.stateChange);
  }
}
